module.exports = __webpack_public_path__ + "img/IRam64_ua.1aed9b38.webp";